import React from 'react';
import { Row, Col } from 'react-bootstrap';

// Own constants/actions/components
import cardstock from 'assets/card-stock.svg';

const CardStockComp = () => {
  return (
    <div className="card-stock">
      <Row>
        <Col xs={4}>
          <img src={cardstock} alt="logo-stock" width="100%" />
        </Col>
        <Col xs={8}>
          <p className="mt-md-4 mt-lg-0">
            Quedan muy pocas Experiencias.
            <br />
            ¡Date prisa!
          </p>
        </Col>
      </Row>
    </div>
  );
};

export default CardStockComp;
